import React from 'react'
import './shopping-car.scss'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import ItemShop from '../../atoms/itemShop/item-shop'
import { pushGtagEvent } from '../../../shared/utils/metricManagementUtil'

const options = {
	renderNode: {
		[BLOCKS.EMBEDDED_ASSET]: (node, next) => (
			<img
				className='f-shopping-content-product-image'
				src={node.data.target.fields.file['es-CO'].url}
				alt={node.data.target.fields.description['es-CO']}
			/>
		),
		[BLOCKS.PARAGRAPH]: (node, next) =>
			next.toString().length ? (
				<p className='f-shopping-content-product-description'>{next}</p>
			) : (
				undefined
			),
	},
}

const ShoppingCar = ({
	samples,
	jsonProductSelec,
	removeSample,
	actionCar,
	labelButton,
}) => {
	
	return (
		<div className='f-shopping'>
			<div className='f-shopping-border'></div>
			<div className='f-shopping-content'>
				<div className='f-shopping-content-product'>
					{documentToReactComponents(jsonProductSelec, options)}
					<span className='f-shopping-content-product-items'>
						{samples.length}
					</span>
				</div>
				<div className='f-shopping-content-elements'>
					{samples.map((sample, key) => (
						<ItemShop
							key={key}
							sample={sample}
							actionClose={() => {
								removeSample(sample.id, sample.size)
								const gtag ={
									event: 'remove_from_cart',
									params:[{
										item_id: sample.id,
										item_name: sample.name,
										affiliation: 'Tena Online',
										item_brand: sample.item_brand,
										item_category: sample.item_category,
										currency:process.env.LOCALE	
									}],
									flow_type: sample.flow_type									
								}
								pushGtagEvent(gtag)
							}}

						/>
					))}
				</div>
				<button onClick={actionCar}  onClickCapture={()=>{
					const gtag ={event: 'begin_checkout', 
						params:[{currency:process.env.LOCALE,}],		
					}
					
					gtag.params.push({flow_type: 'muestra gratis'})
					samples.map((sample) => (
						gtag.params.push({item_id: sample.id,
							item_name: sample.name,
							affiliation: 'Tena Online',
							item_brand: sample.item_brand,
							item_category: sample.item_category}
						)
					))					
					pushGtagEvent(gtag)
				}} className='f-shopping-content-button'>
					{labelButton}
				</button>
			</div>
		</div>
	)
}

export default ShoppingCar